import { createContext } from "react";

export const PrintContext = createContext<{
  requestCsvDownload: () => void;
}>({
  requestCsvDownload: () => {
    console.warn("PrintContext.requestCsvDownload called without provider");
  },
});
